module.exports = __webpack_public_path__ + "img/right_3.c4214c22.jpg";